<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
    <!-- <template #IMAGE="{row,value,field}">
			<img @click="preview(row[field.key])" style="height: 60px;" v-if="row[field.key]" :src="$globalUrl+row[field.key]">
			<span v-else></span>
		</template> -->
    <template #PREVIEW="{params,visible}">
      <img style="width: 100%;" :src="params.src" />
    </template>
  </cTable>
</template>
<script>
import { getList } from "@/api/order/evidenceHistory";
import cTable from "@/base/common/index";
import { getSelectType } from "@/api/public";
// import { getAllClient, getCompanies } from "@/api/user/client";
// import { getCurrency } from "@/api/finance/currency";
// import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
import { getWarehouse } from "@/api/storage/warehouse";
// import { getChargingType } from "@/api/double/list";
// import { getConfig,getSubjectCost } from "@/api/tracker/cost_page";
export default {
  name: "evidenceHistory",
  components: {
    cTable
  },
  async created() {
    // this.status = (await getSelectType('INTERCEPT_STATUS')).data.payload['INTERCEPT_STATUS']
    // this.statusObj = this.status.reduce((a,b)=>{
    // 	a[b.value] = b.label
    // 	return a
    // },{})
    // let agentList = (await getAgent()).data.payload.rows
    this.header.searchs.forEach(async item => {
      // if(item.key === 'status')item.options = this.status
      // if (item.key === "client_id")
      // item.options = (await getAllClient()).data.payload.rows;
      // if (item.key === "customer_service_id")
      // 	item.options = (
      // 		await getUser({ standard: "CustomerService" })
      // 	).data.payload.rows;
    });
    // this.modals.add.fields.forEach(t=>{
    // 	if(t.key === 'cod_agent')t.options = agentList
    // })
  },
  methods: {
    preview(src) {
      this.current = 0;
      this.$refs["table"].getModal("preview").open({ src });
    }
  },
  data() {
    let that = this;
    return {
      status: [],
      statusObj: [],
      agentList: [],
      configs: {},
      client: [],
      companies: [],
      unit: [],
      bubble: [],
      currencyList: [],
      SubjectCost: [],
      methods: {
        getSelectType,
        list(params) {
          return getList(params);
        }
      },
      modals: {
        preview: {
          config: {
            title: this.$t("preview")
          },
          contentSlot: "PREVIEW",
          footer: {
            show: false
          }
        },
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data.airway_number = data.airway_number.split("\n");
              this.$page.handleRequestMethods("update", data, true).then(e => {
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              styles: {
                top: "30px"
              },
              width: 700
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              status: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ status: 24 }, { airway_number: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_number",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 8
              }
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 3
              }
            },
            {
              key: "status",
              name: () => this.$t("tip"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tip");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.status;
                }
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            },
            config: { label: "account", value: "id" },
            methods: {
              async list({ field, row }) {
                let res = (await getAllClient()).data.payload.rows;
                field.options = res;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "warehouse_id",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id"
            },
            methods: {
              async list({ field }) {
                field.options = (await getWarehouse()).data.payload.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("order_number");
            },
            bind: {
              type: "textarea",
              rows: 2
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("Update Status"),
            //   fnName: "updateStatus",
            //   type: "updateStatus",
            //   bind: {
            //     type: "primary",
            //   },
            // },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            updateStatus() {
              this.getModal("add").open(
                {
                  airway_number: this.selectAll
                    .map(t => t.airway_number)
                    .join("\n")
                },
                function() {
                  this.setTitle(this.$t("Update Status"));
                }
              );
            },
            export({ searchForm }) {
              let data = JSON.parse(JSON.stringify(searchForm));
              data.export = 1;
              this.handleRequestMethods("list", data, false, true).then(res => {
                window.open(this.$globalUrl + res.payload.src);
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: this.$t("order_number"),
          key: "airway_number",
          minWidth: 120,
          header: {
            copy: true
          }
        },
        {
          name: this.$t("clientName"),
          key: "customer",
          minWidth: 120
        },
        {
          name: this.$t("service"),
          key: "service",
          minWidth: 120
        },
        {
          name: this.$t("skuLength"),
          key: "length",
          width: 120,
          render: (h, p) => {
            return h(
              "Button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !p.row[p.field.key]
                },
                on: {
                  click: () => {
                    this.preview(p.row[p.field.key]);
                  }
                }
              },
              this.$t("preview")
            );
          }
        },
        {
          name: this.$t("skuWidth"),
          key: "width",
          width: 120,
          render: (h, p) => {
            return h(
              "Button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !p.row[p.field.key]
                },
                on: {
                  click: () => {
                    this.preview(p.row[p.field.key]);
                  }
                }
              },
              this.$t("preview")
            );
          }
        },
        {
          name: this.$t("skuHeight"),
          key: "height",
          width: 120,
          render: (h, p) => {
            return h(
              "Button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !p.row[p.field.key]
                },
                on: {
                  click: () => {
                    this.preview(p.row[p.field.key]);
                  }
                }
              },
              this.$t("preview")
            );
          }
        },
        {
          name: this.$t("Weight"),
          key: "weight",
          width: 120,
          render: (h, p) => {
            return h(
              "Button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !p.row[p.field.key]
                },
                on: {
                  click: () => {
                    this.preview(p.row[p.field.key]);
                  }
                }
              },
              this.$t("preview")
            );
          }
        },
        {
          name: this.$t("Body"),
          key: "body",
          width: 120,
          render: (h, p) => {
            return h(
              "Button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !p.row[p.field.key]
                },
                on: {
                  click: () => {
                    this.preview(p.row[p.field.key]);
                  }
                }
              },
              this.$t("preview")
            );
          }
        },
        {
          name: this.$t("allow_depart"),
          key: "from_country",
          minWidth: 120
        },
        {
          name: this.$t("allow_arrive"),
          key: "to_country",
          minWidth: 120
        },
        {
          name: this.$t("inbound_time"),
          key: "inbound_time",
          minWidth: 120
        },
        {
          name: this.$t("claim_weight"),
          key: "claim_weight",
          minWidth: 120
        },
        {
          name: this.$t("check_weight"),
          key: "check_weight",
          minWidth: 120
        },
        {
          name: this.$t("charge_params"),
          key: "actual_weight",
          minWidth: 120
        },
        {
          name: this.$t("warehouse"),
          key: "warehouse",
          minWidth: 120
        },
        {
          name: this.$t("operate"),
          key: "create_name",
          minWidth: 120
        },
        {
          name: this.$t("evidenceTime"),
          key: "create_time",
          minWidth: 120
        }
        /* {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
							// id:1258
            },
          ],
          methods: {
          },
        }, */
      ]
    };
  }
};
</script>
<style lang="scss" scoped></style>
